import { useTranslation } from 'react-i18next'
import { ListTravelSheets } from '~/features/common/Drivers/TravelSheets/ListTravelSheets'
import { Container, PageContainer } from '~/shared/ui/Layout'

export const ListTravelSheetPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('trip sheets')}>
      <Container>
        <ListTravelSheets />
      </Container>
    </PageContainer>
  )
}
